import { fetchRequest } from "./utilities/fetchRequest.js";
import { queryString } from "./utilities/string.js";
import $ from 'jquery';

const __yidun = {
    init() {
        // initNECaptcha为全局函数，可直接调用
        initNECaptcha({
            // config对象，参数配置
            // captchaId: '5be5a701dfef49faa1e0e786ecd3647b', // 正常防刷
            captchaId: 'a64661349ffb4ef3a37ca13afd03fd6e', // 强校验防采集

            // captchaId: 'a64661349ffb4ef3a37ca13afd03fd6e',
            element: '#captcha',
            onVerify: function (err, data) {
                setTimeout(function () {
                    if (data.validate) {
                        __yidun.sendValidateFun(data.validate);
                    } else {
                        window.location.reload();
                    }
                }, 1000);
            }
        });

        __yidun.callback = queryString('callback');
    },
    sendValidateFun(validate) {
        fetchRequest({
            url: '/yidun/ajaxVerify/',
            type: 'post',
            parma: {
                verify_code: validate,
                callback: __yidun.callback,
                antiIpfilterkey: queryString('antiIpfilterkey'),
                antiIpfiltersn: queryString('antiIpfiltersn'),
                antiIpfiltetime: queryString('antiIpfiltetime')
            },
            successFun(data) {
                if (data.code != 0) {
                    layer.msg(data.msg);
                    return false;
                }

                window.location.href = __yidun.callback;
            }
        });
    },

};

$(function () {
    __yidun.init();
});
